import { ApiState } from 'scenes/common/helpers/apiData/types';

export class ApiError<T> extends Error {
  public data?: T;

  public httpCode?: string;

  constructor(
    message = 'An API error occurred',
    code: string = ApiState.Error,
    data?: T,
    httpCode?: string
  ) {
    super(message);

    this.name = code;
    this.data = data;
    this.httpCode = httpCode;
  }
}
